var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.buttons && !_vm.autocomplete
        ? _c("v-select", {
            attrs: {
              items: _vm.staff,
              value: _vm.value,
              "prepend-inner-icon": _vm.hideIcon ? null : "people",
              loading: _vm.loading,
              hideDetails: _vm.hideDetails,
              clearable: _vm.clearable,
              rules: _vm.rules,
              disabled: _vm.disabled,
              outlined: "",
              dense: "",
              "return-object": "",
              "no-data-text": "No staff available",
              "item-text": "name",
              "item-value": "id",
              label: "Select Staff",
            },
            on: {
              input: function ($event) {
                return _vm.$emit("input", $event)
              },
              "click:clear": function ($event) {
                return _vm.$emit("clear")
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.autocomplete && !_vm.buttons && !_vm.loading
        ? _c("v-autocomplete", {
            staticClass: "soli-blue-text",
            attrs: {
              value: _vm.value,
              items: _vm.staff,
              "search-input": _vm.search,
              "hide-details": _vm.hideDetails,
              "prepend-inner-icon": _vm.hideIcon ? null : "people",
              loading: _vm.loading,
              disabled: _vm.disabled,
              "error-messages": _vm.error,
              rules: _vm.rules,
              "return-object": "",
              outlined: "",
              autofocus: "",
              dense: "",
              "item-value": "id",
              "item-text": "name",
              "no-data-text": "No users found",
              label: "Select Staff",
            },
            on: {
              "update:searchInput": function ($event) {
                _vm.search = $event
              },
              "update:search-input": function ($event) {
                _vm.search = $event
              },
              input: function ($event) {
                return _vm.$emit("input", $event)
              },
              keydown: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                $event.preventDefault()
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "item",
                  fn: function (data) {
                    return [
                      _c("v-list-item-avatar", [
                        _c("img", {
                          attrs: {
                            src: data.item.profile_photo_path
                              ? `/api/image-service/40x40/${data.item.profile_photo_path}`
                              : data.item.profile_photo_url,
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-list-item-content",
                        { class: { "disabled-item": data.item.disabled } },
                        [
                          _c("v-list-item-title", {
                            domProps: { innerHTML: _vm._s(data.item.name) },
                          }),
                          _vm._v(" "),
                          _vm.can("Work") && _vm.$page.props.staffView
                            ? _c("v-list-item-subtitle", {
                                domProps: {
                                  innerHTML: _vm._s(data.item.email),
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      data.item.locations &&
                      !data.item.locations
                        ?.map((e) => e.id)
                        .includes(
                          _vm.$page.props.auth.user.selected_location.id
                        )
                        ? _c(
                            "div",
                            { staticClass: "flex flex-col align-end my-auto" },
                            [
                              _c("v-icon", { attrs: { color: "dark" } }, [
                                _vm._v("wrong_location"),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ],
              null,
              false,
              903001208
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }